export default __webpack_public_path__ + "static/media/IC_Firefox_48x48.7dc7302a.png";